import CaseUtil from '@common/lib/caseUtil';
import ReferralApi from '~referral/api/referral';

const BASE_NAME = 'referral/referral';
const SET_REFERRAL_COUPON = `${BASE_NAME}/SET_REFERRAL_COUPON`;
const SET_REFERRAL_DATA = `${BASE_NAME}/SET_REFERRAL_DATA`;

export function fetchReferralCoupon() {
  return async (dispatch, getState) => {
    const state = getState().referral;
    const { referralCoupon } = state?.referral || {};

    if (referralCoupon) return;

    try {
      const response = await ReferralApi.fetchReferralCoupon();
      dispatch({
        type: SET_REFERRAL_COUPON,
        payload: response.couponCode,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

export function loadReferralData(
  pageNumber = 1, perPage = 10, product = 'mentees',
) {
  return async (dispatch) => {
    try {
      const json = await ReferralApi.loadReferralData({
        page_number: pageNumber,
        per_page: perPage,
        product,
      });

      dispatch({
        type: SET_REFERRAL_DATA,
        payload: CaseUtil.toCase('camelCase', json),
        pageNumber: pageNumber || 1,
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };
}

const initialState = {
  referralCoupon: null,
  referralData: null,
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_REFERRAL_COUPON:
      return {
        ...state,
        referralCoupon: payload,
      };
    case SET_REFERRAL_DATA:
      return {
        ...state,
        referralData: payload,
      };
    default:
      return state;
  }
}
